import React, { useState } from 'react';
import { t } from '@lingui/macro';

import Vector from '@rover/icons/svg/vector.svg';
import { Text } from '@rover/kibble/core';
import Row from '@rover/kibble/patterns/Row';
import type { UserInformationAddress } from '@rover/rsdk/src/apiClient/latest/model/userInformationAddress';

import useTemporaryAddress from '../hooks/useTemporaryAddress';
import { AddressType } from '../LocationInput.constants';
import { createAddressOptionRowWebProps } from '../utils';

import AddressModal from './AddressForm/AddressModal';
import EditButton from './EditButton';
import OptionLabel from './OptionLabel';

type Props = {
  blurInput?: () => void;
  onEdit: (newAddressData: UserInformationAddress) => void;
  onSelectAddress?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

export default function TemporaryAddressOption({
  blurInput,
  onEdit,
  onSelectAddress,
}: Props): JSX.Element {
  const { formattedAddress: temporaryFormattedAddress, address: temporaryAddress } =
    useTemporaryAddress();

  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  const onClickEdit = (e): void => {
    e.stopPropagation();
    setIsAddressModalOpen(true);
  };

  const onCloseModal = (): void => {
    setIsAddressModalOpen(false);
    blurInput?.();
  };
  return (
    <OptionLabel title={t`Temporary Address`}>
      <Row
        onClick={() => {
          const event = { preventDefault: () => {} } as React.MouseEvent;
          onSelectAddress?.(event);
        }}
        ariaLabel={t`Temporary address`}
        label={t`Temporary address`}
        sublabel={
          <Text
            size="100"
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            textColor="tertiary"
          >
            {temporaryFormattedAddress || t`None`}
          </Text>
        }
        leftItem={<Vector width={24} height={24} />}
        rightItem={<EditButton onClick={onClickEdit} onBlur={blurInput} />}
        webProps={createAddressOptionRowWebProps((e) => onSelectAddress?.(e), blurInput)}
      />
      <AddressModal
        isOpen={isAddressModalOpen}
        onClose={onCloseModal}
        onEdit={onEdit}
        isEditMode
        addressType={AddressType.Temporary}
        address={temporaryAddress}
      />
    </OptionLabel>
  );
}
